import { render } from "./up_company_detail_model.vue?vue&type=template&id=c3ecee84&scoped=true"
import script from "./up_company_detail_model.vue?vue&type=script&lang=js"
export * from "./up_company_detail_model.vue?vue&type=script&lang=js"

import "./up_company_detail_model.vue?vue&type=style&index=0&id=c3ecee84&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ecee84"]])

export default __exports__